import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Layout from '../../../../components/ui/Layout/Layout'

import validateAccountIdentifier from '../../../../services/validation/AccountIdentifier'

import AccountRecoveryForm from '../AccountRecoveryForm/AccountRecoveryForm'

import { RECOVERY_REQUEST } from '../../../../services/data/accountRecoverySteps.json'

import { setGAPageView } from '../../../../services/analytics/google-analytics'

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  font-weight: var(--font-weight-boldest);
  color: var(--color-secondary);
`

const Description = styled.p`
  text-align: center;
`

const MainView = props => {
  const {
    setRecoveryRequestId,
    setMaskedData,
    setRecoveryStep,
    replace,
    doRequestAccountRecovery,
    location,
  } = props

  React.useState(() => {
    setGAPageView(location.pathname)
  }, [])

  return (
    <Layout {...props}>
      <Helmet />
      <Title>Account Recovery</Title>
      <Description>
        Enter your registered email address. Make sure that you are using a
        verified email address for you to recover your account.
      </Description>
      <AccessibleForm
        enableReinitialize
        initialValues={{}}
        validate={validateAccountIdentifier}
        onSubmit={doRequestAccountRecovery({
          setRecoveryRequestId,
          setMaskedData,
          setRecoveryStep,
          replace,
          searchString: location.search,
        })}
        component={AccountRecoveryForm}
        action="/a/account-recovery"
        method="post"
      />
    </Layout>
  )
}

MainView.defaultProps = {
  primaryInfo: null,
  step: RECOVERY_REQUEST,
  push: null,
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  step: PropTypes.number,
  push: PropTypes.func,
}

export default withRouter(MainView)
